module.exports = require("use-long-press");